import { render, staticRenderFns } from "./WritingsInReviewTable.vue?vue&type=template&id=2fa065e2&"
import script from "./WritingsInReviewTable.vue?vue&type=script&lang=js&"
export * from "./WritingsInReviewTable.vue?vue&type=script&lang=js&"
import style0 from "./WritingsInReviewTable.vue?vue&type=style&index=0&id=2fa065e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports